var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-popover',{attrs:{"trigger":"hover"}},[_c('template',{slot:"content"},[_c('p',[_vm._v("建议图片大小为：宽：400，高："+_vm._s(_vm.height)+"，效果最佳")])]),_c('a-icon',{staticStyle:{"color":"#f37b1d"},attrs:{"type":"exclamation-circle"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }